<template>
  <div class="aftersale-detail">
    <el-table :data="aftersaleDetailTableData" border style="width: 100%">
      <el-table-column type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="created_at" label="日期" width="120">
      </el-table-column>
      <el-table-column prop="as_number" label="服务编号" width="130">
      </el-table-column>
      <el-table-column prop="order_number" label="订单号" width="120">
      </el-table-column>
      <el-table-column prop="user_name" label="客户">
      </el-table-column>
      <el-table-column prop="user_address" label="地址" width="150">
      </el-table-column>
      <el-table-column prop="applied_num" label="申请数量">
      </el-table-column>
      <el-table-column prop="received_num" label="入库数量">
      </el-table-column>
      <!-- <el-table-column prop="" label="入库异常">
      </el-table-column> -->
      <el-table-column prop="accepted_num" label="出库数量">
      </el-table-column>
      <el-table-column prop="abnormal" label="异常原因">
      </el-table-column>
      <el-table-column prop="send_amount" label="责任方">
      </el-table-column>
      <el-table-column prop="as_statusName" label="售后状态">
      </el-table-column>
      <el-table-column prop="as_typeName" label="售后类型">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getAsOrderStatus, getAsOrderType, getAftersaleDetail } from '@/models/aftersaleModel'
export default {
  data () {
    return {
      aftersaleDetailTableData: [],
      statusList: [],
      typeList: []
    }
  },
  mounted () {
    this.getAftersaleDetail(this.$route.query.number)
  },
  methods: {
    async getAftersaleDetail (number) {
      let params = {
        as_number: number,
        order_type: 0
      }
      this.statusList = await getAsOrderStatus()
      this.typeList = await getAsOrderType()
      let data = await getAftersaleDetail(params)
      this.aftersaleDetailTableData = data.detail
      for (let i of this.aftersaleDetailTableData) {
        i.as_statusName = this.statusList.filter(item => item.value === data.as_status)[0].label
        i.as_typeName = this.typeList.filter(item => item.value === i.as_type)[0].label
        i.user_address = data.user_address
        i.user_name = data.user_name
        if (i.applied_num !== i.received_num) {
          i.abnormal = '出库异常'
        }
      }
    }
  }
}
</script>

<style lang="scss">
.aftersale-detail {
  padding: 30px 0px 0px 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/aftersale/abnormal-detail.vue